import { UserPermission } from '@globaleris/ui.library'
import { generateIconsFromConfiguration } from '../../../helpers/dataTableActionIconHelper'
import { hasPermission, hasResource } from '../../../helpers/permissionsHelper'
import i18n from '../../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../../model'
import { Resources } from '../../../model/RBAC/constants'
import { getObjectionsDisagreementAction } from '../../contactsInfo/contactsInfo.service'
import {
  ClientFileModel,
  ContactInfoModel,
  ContactInfoWithPrincipalIcon,
  SubjectModel
} from '../clients.model'

export const clientDataMapper = (clientData: SubjectModel): ClientFileModel => {
  return {
    ...clientData,
    contactInfo: clientData.contactInfo ? contactsMapper(clientData.contactInfo) : []
  }
}

export const contactsMapper = (contactInfo: ContactInfoModel[]): ContactInfoWithPrincipalIcon[] => {
  return contactInfo
    .map(contact => {
      return {
        ...contact,
        iconConfiguration: contact.principal ? getPrincipalAction() : undefined
      }
    })
    .map(contact => {
      return completeDataTableActions(contact)
    })
}

const getPrincipalAction = (): DataTableActionConfiguration[] => {
  return [
    {
      icon: ActionIcons.PRINCIPAL,
      tooltip: i18n.t('clientFile:components.contactsCard.dataTable.tooltips.principal')
    }
  ]
}

export const completeDataTableActions = (
  item: ContactInfoWithPrincipalIcon
): ContactInfoWithPrincipalIcon => {
  return {
    ...item,
    actions:
      item.iconConfiguration &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfiguration(item, item.iconConfiguration),
        new Map<ActionIcons, Function>([])
      )
  }
}

export const filterApplicableActionsConfiguration = (
  item: ContactInfoWithPrincipalIcon,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.PRINCIPAL: {
        if (item.principal) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
    }
  })
  return applicableActionsConfiguration
}

// export const hasClientPermission = hasPermission(Resources.Client, [
//   UserPermission.EDIT,
//   UserPermission.READ_ONLY
// ])
// export const hasCommercialResource = hasResource(Resources.Commercial)
// export const hasAdministrationResource = hasResource(Resources.Administration)
